import { SAVE_PAGE_FILTERS } from '../constants';
import { IPageFiltersData } from '../types';

export const savePageFilters = (pageFilters: IPageFiltersData) => ({
  type: SAVE_PAGE_FILTERS,
  payload: pageFilters,
});
